/* The widget -> Designer Review hand-offs (forma badge SYNC_PLAN D9, and the
 * Master updates row for the spec), as one pure decision so it can be tested without a browser. */

export type FormaIntentAction = 'idle' | 'wait' | 'start' | 'consume';

/**
 * idle     no pending intent (none, or already handled)
 * wait     the forma doc is not live yet, or its updates have not loaded
 * start    open the forma Review now
 * consume  intent handled, but nothing to review (rows resolved meanwhile)
 */
export function formaIntentAction(input: {
  intentTs: number | null;
  handledTs: number | null;
  canView: boolean;
  live: boolean;
  loaded: boolean;
  rowCount: number;
}): FormaIntentAction {
  if (input.intentTs == null || input.intentTs === input.handledTs) return 'idle';
  if (!input.canView || !input.live || !input.loaded) return 'wait';
  return input.rowCount > 0 ? 'start' : 'consume';
}
